import React, { useState, useEffect } from "react";
import { Plus, AlertCircle, Trash2, X } from "lucide-react";
import "./ArticleModal.scss";
import {
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { fetchPickArticleGroups } from "../../Services/FetchArticleGroups";
import { fetchPickUnit } from "../../Services/FetchUnitsList";
import { createUnit } from "../UnitCRUD/UnitService";
import UnitModal from "../UnitCRUD/UnitModal";
import { createArticleGroup } from "../ArticleGroupsCRUD/ArticleGroupService";
import ArticleGroupModal from "../ArticleGroupsCRUD/ArticleGroupModal";
import { errorAlert } from "../../Components/Alerts";
import { fetchVatRates } from "../../Services/ArticleService";
import {
  createArticle,
  fetchArticleById,
  updateArticle,
} from "./ArticleService";
import { ApiLink } from "../../APILink/ApiLink";
import axios from "axios";
import authHeader from "../../Auth/authHeader";
import FormControlLabel from "@mui/material/FormControlLabel";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
} from "@mui/material";
import { SimpleAutoSelect } from "../../Components/SimpleAutoSelect";
import IOSSwitch from "../../Components/IOSSwitch";
import { fetchActiveCompanyUnits } from "../../GetData/CompanyUnitsData";
import { getAuthData } from "../../Auth/getAuthData";
import PriceField from "../../Components/NumberFieldFormater";
import {
  AddAnElementButton,
  AddElementsButton,
  CloseFormButton,
} from "../../Components/AddElementsButton";

const ledgers = [
  {
    Ledgerid: 107,
    LedgerName: "107 Artikull Mall",
  },
  {
    Ledgerid: 702,
    LedgerName: "702 Artikull Sherbim",
  },
];

export const saleTypes = [
  { id: 1, name: "Pakicë" },
  { id: 2, name: "Shumicë" },
];

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const extractErrorMessage = (err, fallback) => {
  const data = err?.response?.data;

  if (typeof data === "string" && data.trim()) return data;
  if (data?.Message) return data.Message;
  if (data?.message) return data.message;
  if (err?.message) return err.message;

  return fallback;
};

export default function ItemFormModal({
  isOpen,
  onClose,
  onSuccess,
  itemToEdit,
}) {
  const headers = authHeader();
  const authData = getAuthData();
  // Përdor emrin fiks si në Token: CompanyUnitID
  const userCompanyUnitID = Number(authData?.companyUnitId || 0);
  const [enableSalesPrice, setEnableSalesPrice] = useState(false);

  const [loading, setLoading] = useState(false);
  const [groups, setGroups] = useState([]);
  const [units, setUnits] = useState([]);
  const [vat, setVat] = useState([]);

  const [isGroupModalOpen, setIsGroupModalOpen] = useState(false);
  const [isUnitModalOpen, setIsUnitModalOpen] = useState(false);

  const [showUnsavedWarning, setShowUnsavedWarning] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [isTrackingChanges, setIsTrackingChanges] = useState(false);
  const [vatPercent, setVatPercent] = useState(0);
  const [isVatDeclarant, setIsVatDeclarant] = useState(false);

  const [companyUnits, setCompanyUnits] = useState([]);
  const [countCompanyUnit, setCountCompanyUnit] = useState(0);

  const [showAdvancedForm, setShowAdvancedForm] = useState(false);

  const editableFields = [
    "name",
    "comment",
    "barcode",
    "groupId",
    "unitId",
    "ledgerId",
    "vatId",
    "purchasePriceNoVat",
    "purchasePriceWithVat",
    "salePriceNoVat",
    "salePriceWithVat",
    "isActive",
    "showInPos",
  ];

  const [articleExist, setArticleExist] = useState("");
  const [msgArticle, setMsgArticle] = useState("");
  const [msgComment, setMsgComment] = useState("");
  const [barcodeExist, setBarcodeExsit] = useState("");
  const [msgBarcode, setMsgBarcode] = useState("");
  const [groupError, setGroupError] = useState("");
  const [unitError, setUnitError] = useState("");
  const [ledgerError, setLedgerError] = useState("");
  const [vatError, setVatError] = useState("");

  // const [vatError, setVatError] = useState("");

  const [formData, setFormData] = useState({
    barcode: "",
    name: "",
    comment: "",
    groupId: "",
    unitId: "",
    ledgerId: "",
    vatId: 0,
    purchasePriceNoVat: 0,
    purchasePriceWithVat: 0,
    articleProduction: "",
    salePriceNoVat: 0,
    salePriceWithVat: 0,
    profitValue: 0,
    profitPercent: 0,
    isActive: true,
    showInPos: true,
    articleotherDetails: [
      {
        articleSalesOptionsID: null,
        isActive: true,
        companyUnitId: "",
        typeOfSales: "", //shumic ose pakic
        newBarcode: "",
        articleUnitID: "",
        articleUnitQty: "",
        newSalesPrice: "",
      },
    ],
  });

  // useEffect(() => {
  //   if (isOpen) {
  //     // loadDependencies();
  //     loadGroups();
  //     loadUnits();
  //     loadVatRates();
  //     fetchNextBarcode();
  //     if (itemToEdit) {
  //       setFormData({
  //         barcode: itemToEdit.Barcode || "",
  //         name: itemToEdit.ArticleName || "",
  //         comment: itemToEdit.Description || "",
  //         groupId: itemToEdit.GroupID || "",
  //         unitId: itemToEdit.UnitID || "",
  //         ledgerId: itemToEdit.LedgerID || "",
  //         vatId: itemToEdit.vatId || 0,
  //         purchasePriceNoVat: itemToEdit.purchasePriceNoVat || 0,
  //         purchasePriceWithVat: itemToEdit.purchasePriceWithVat || 0,
  //         salePriceNoVat: itemToEdit.salePriceNoVat || 0,
  //         salePriceWithVat: itemToEdit.salePriceWithVat || 0,
  //         profitValue: itemToEdit.profitValue || 0,
  //         profitPercent: itemToEdit.profitPercent || 0,
  //         isActive: itemToEdit.isActive ?? true,
  //         showInPos: itemToEdit.showInPos ?? true,
  //       });
  //     } else {
  //       resetForm();
  //     }
  //     setHasChanges(false);
  //     setShowUnsavedWarning(false);
  //   }
  // }, [isOpen, itemToEdit]);

  useEffect(() => {
    if (isOpen) {
      setIsTrackingChanges(false);
      // 1. Ngarkimi i dependencave (Gjithmonë)
      loadGroups();
      loadUnits();
      loadVatRates();
      setMsgBarcode("");
      setMsgArticle("");
      setMsgComment("");
      setGroupError("");
      setUnitError("");
      setLedgerError("");
      setVatError("");
      setEnableSalesPrice(false);
      if (itemToEdit) {
        // 2. MODE EDITIM: Thirrja e API-së për të marrë të dhënat e plota (Master + Details)
        const loadFullArticle = async () => {
          setLoading(true);
          try {
            const data = await fetchArticleById(itemToEdit);

            // const selectedVAT = vat.find((v) => v.VATID === data.VAT); // Gjej VAT ku VATID barazohet me VAT në item
            // const vatPercent = selectedVAT ? selectedVAT.VATPercent : null; // Merr VATPercent nëse ekziston
            const selectedVAT = vat.find((v) => v.VATID === data.VAT);
            const vatPercent = selectedVAT ? selectedVAT.VATPercent : 0;
            // Mbushim formën me të dhënat e freskëta nga DB
            setFormData({
              barcode: data.Barcode || "",
              name: data.ArticleName || "",
              comment: data.Description || "",
              groupId: data.GroupID || "",
              unitId: data.UnitID || "",
              ledgerId: data.LedgerID || "",
              vatId: data.VAT || 0,
              articleProduction: data.ArticleProduction || "",
              purchasePriceWithVat: data.PurchasePrice || 0,
              salePriceWithVat: data.SalesPrice || 0,
              isActive: data.IsActive,
              showInPos: data.TouchScreen,
              articleotherDetails: data.ArticleOtherDetails.map((item) => ({
                articleSalesOptionsID: item.ArticleSalesOptionsID,
                isActive: item.IsActive ?? true,
                companyUnitId: item.CompanyUnitId,
                typeOfSales: item.TypeOfSales,
                newBarcode: item.NewBarcode,
                articleUnitID: item.ArticleUnitID,
                articleUnitQty: item.ArticleUnitQty,
                newSalesPrice: item.NewSalesPrice,
              })),
            });
            if (groups.length > 0 && data.GroupID) {
              const selectedGroup = groups.find(
                (g) => g.GroupID === data.GroupID,
              );
              if (selectedGroup) {
                setGroupName(selectedGroup);
              }
            }

            calcPriceFromPriceWithVAT(
              data.PurchasePrice,
              vatPercent,
              "purchaseWithVAT",
            );
            calcPriceFromPriceWithVAT(
              data.SalesPrice,
              vatPercent,
              "salesWithVAT",
            );

            // calcPriceFromPriceWithVAT(
            //   data.PurchasePrice,
            //   vatPercent,
            //   "purchaseWithVAT",
            // );
            // calcPriceFromPriceWithVAT(
            //   data.SalesPrice,
            //   vatPercent,
            //   "salesWithVAT",
            // );

            if (data.ArticleOtherDetails.length > 1) {
              setShowAdvancedForm(true);
              setEnableSalesPrice(true);
            } else {
              setShowAdvancedForm(false);
              setEnableSalesPrice(false);
            }
          } catch (err) {
            const serverMsg = extractErrorMessage(
              err,
              "Gabim gjatë ngarkimit të artikullit.",
            );
            errorAlert(serverMsg);
          } finally {
            setLoading(false);
            setIsTrackingChanges(true);
          }
        };
        loadFullArticle();
      } else {
        // 3. MODE SHTIM: Resetojmë formën dhe marrim barkodin e ri
        resetForm();
        fetchNextBarcode();
        setIsTrackingChanges(true);
      }

      setHasChanges(false);
      setShowUnsavedWarning(false);
    }
  }, [isOpen, itemToEdit]);

  const addDefaultArticleDetail = () => {
    const { barcode, unitId, salePriceWithVat, articleotherDetails } = formData;

    // Siguro që articleotherDetails është gjithmonë array
    const detailsArray = articleotherDetails || [];

    // Vetëm nëse ka vlera kryesore
    if (barcode && unitId && salePriceWithVat) {
      // Kontrollo për duplicate
      const exists = detailsArray.some(
        (d) => d.newBarcode === barcode && d.articleUnitID === unitId,
      );

      if (!exists) {
        const newDetail = {
          isActive: true,
          companyUnitId: null,
          typeOfSales: 1, // ose "pakic" si default
          newBarcode: barcode,
          articleUnitID: unitId,
          articleUnitQty: null,
          newSalesPrice: salePriceWithVat,
        };

        setFormData((prev) => ({
          ...prev,
          // krijo array nëse nuk ekziston
          articleotherDetails: [...(prev.articleotherDetails || []), newDetail],
        }));
      }
    }
  };

  // Funksion për të ngarkuar vetëm grupet
  const loadGroups = async () => {
    try {
      const fetchedGroups = await fetchPickArticleGroups();
      setGroups(fetchedGroups);
    } catch (error) {
      errorAlert("Gabim gjatë shfaqjes se te dhenave");
    }
  };

  // Funksion për të ngarkuar vetëm unit-et
  const loadUnits = async () => {
    try {
      const fetchedUnits = await fetchPickUnit();
      setUnits(fetchedUnits);
    } catch (error) {
      errorAlert("Gabim gjatë shfaqjes se te dhenave");
    }
  };

  const loadVatRates = async () => {
    try {
      const fetchVatrates = await fetchVatRates();
      setVat(fetchVatrates);
    } catch (error) {
      errorAlert("Gabim gjatë shfaqjes se te dhenave");
    }
  };
  const resetForm = () => {
    setFormData({
      barcode: "",
      name: "",
      comment: "",
      groupId: "",
      unitId: "",
      ledgerId: "",
      vatId: 0,
      purchasePriceNoVat: 0,
      purchasePriceWithVat: 0,
      articleProduction: "",
      salePriceNoVat: 0,
      salePriceWithVat: 0,
      profitValue: 0,
      profitPercent: 0,
      isActive: true,
      showInPos: true,
      articleotherDetails: [
        {
          articleSalesOptionsID: null,
          isActive: true,
          companyUnitId: "",
          typeOfSales: "",
          newBarcode: "",
          articleUnitID: "",
          articleUnitQty: "",
          newSalesPrice: "",
        },
      ],
    });
    setGroupName(null);
    setUnitName(null);
    setLedgerName(null);
    setMsgBarcode("");
    setMsgArticle("");
    setMsgComment("");
  };

  // Funksion për toggle company unit
  // const toggleCompanyUnit = (unitId) => {
  //   setFormData((prev) => {
  //     const ids = prev?.companyUnitIds || []; // <--- fallback në array bosh
  //     const newIds = ids.includes(unitId)
  //       ? ids.filter((id) => id !== unitId)
  //       : [...ids, unitId];
  //     return { ...prev, companyUnitIds: newIds };
  //   });
  // };

  // --- Measurement Units ---
  const addOtherArticleDetails = () => {
    if (isTrackingChanges) setHasChanges(true);
    setFormData((prev) => ({
      ...prev,
      articleotherDetails: [
        ...(prev.articleotherDetails || []), // nëse është null ose undefined, përdor array bosh
        // { unit: "", conversionFactor: 1, isBase: false },
        {
          isActive: true,
          companyUnitId: "",
          newBarcode: "",
          articleUnitID: "",
          newSalesPrice: "",
        },
      ],
    }));
  };

  const removeOtherArticleDetails = (index) => {
    if (isTrackingChanges) setHasChanges(true);
    setFormData((prev) => ({
      ...prev,
      articleotherDetails: prev.articleotherDetails.filter(
        (_, i) => i !== index,
      ),
    }));
  };

  // const clickBtn = () => {
  //   console.log(formData);
  // };

  // const updateMeasurementUnit = (index, field, value) => {
  //   setFormData((prev) => {
  //     const newUnits = [...prev.measurementUnits];
  //     newUnits[index] = { ...newUnits[index], [field]: value };
  //     if (field === "isBase" && value === true) {
  //       newUnits.forEach((u, i) => {
  //         if (i !== index) u.isBase = false;
  //       });
  //       prev.baseUnit = newUnits[index].unit;
  //     }
  //     return { ...prev, measurementUnits: newUnits };
  //   });
  // };
  const updateOtherArticleDetils = (index, key, value) => {
    if (isTrackingChanges) setHasChanges(true);
    setFormData((prev) => ({
      ...prev,
      articleotherDetails: (prev.articleotherDetails || []).map((details, i) =>
        i === index ? { ...details, [key]: value } : details,
      ),
    }));
  };

  // const addPrice = () => {
  //   setFormData({
  //     ...formData,
  //     prices: [
  //       ...(formData.prices || []),
  //       {
  //         companyUnitId: "all",
  //         unit: "",
  //         priceType: "",
  //         amount: 0,
  //         currency: "USD",
  //       },
  //     ],
  //   });
  // };

  // const removePrice = (index) => {
  //   const updated = [...formData.prices];
  //   updated.splice(index, 1);
  //   setFormData({ ...formData, prices: updated });
  // };

  // const updatePrice = (index, field, value) => {
  //   const updated = [...formData.prices];
  //   updated[index][field] = value;
  //   setFormData({ ...formData, prices: updated });
  // };

  // const addBarcode = () => {
  //   setFormData((prev) => ({
  //     ...prev,
  //     barcodes: [
  //       ...(prev.barcodes || []),
  //       {
  //         number: "",
  //         linkedUnit: "",
  //         isPrimary: false,
  //       },
  //     ],
  //   }));
  // };

  // const updateBarcode = (index, field, value) => {
  //   setFormData((prev) => {
  //     const updated = [...(prev.barcodes || [])];
  //     updated[index] = {
  //       ...updated[index],
  //       [field]: value,
  //     };
  //     return { ...prev, barcodes: updated };
  //   });
  // };

  // const removeBarcode = (index) => {
  //   setFormData((prev) => {
  //     const updated = [...(prev.barcodes || [])];
  //     updated.splice(index, 1);
  //     return { ...prev, barcodes: updated };
  //   });
  // };

  // const handleChange = (field, value) => {
  //   setHasChanges(true);
  //   setFormData((prev) => {
  //     const newData = { ...prev, [field]: value };

  //     if (["vatRate", "purchasePriceNoVat", "salePriceNoVat"].includes(field)) {
  //       return calculatePrices(newData, field);
  //     }

  //     if (field === "purchasePriceWithVat") {
  //       const noVat = value / (1 + prev.vatId / 100);
  //       return calculatePrices(
  //         { ...newData, purchasePriceNoVat: noVat },
  //         "purchasePriceNoVat",
  //       );
  //     }

  //     if (field === "salePriceWithVat") {
  //       const noVat = value / (1 + prev.vatId / 100);
  //       return calculatePrices(
  //         { ...newData, salePriceNoVat: noVat },
  //         "salePriceNoVat",
  //       );
  //     }

  //     return newData;
  //   });
  // };
  const handleChange = (field, value) => {
    setFormData((prev) => {
      // ✅ Aktivizo changes VETËM për fusha reale
      if (
        isTrackingChanges &&
        editableFields.includes(field) &&
        prev[field] !== value
      ) {
        setHasChanges(true);
      }

      const newData = { ...prev, [field]: value };

      // if (["vatRate", "purchasePriceNoVat", "salePriceNoVat"].includes(field)) {
      //   return calculatePrices(newData, field);
      // }

      // if (field === "purchasePriceWithVat") {
      //   const noVat = value / (1 + prev.vatId / 100);
      //   return calculatePrices(
      //     { ...newData, purchasePriceNoVat: noVat },
      //     "purchasePriceNoVat",
      //   );
      // }

      // if (field === "salePriceWithVat") {
      //   const noVat = value / (1 + prev.vatId / 100);
      //   return calculatePrices(
      //     { ...newData, salePriceNoVat: noVat },
      //     "salePriceNoVat",
      //   );
      // }

      return newData;
    });
  };

  // const calculatePrices = (data) => {
  //   const vatMultiplier = 1 + data.vatId / 100;
  //   const purchasePriceWithVat = +(
  //     data.purchasePriceNoVat * vatMultiplier
  //   ).toFixed(2);
  //   const salePriceWithVat = +(data.salePriceNoVat * vatMultiplier).toFixed(2);
  //   const profitValue = +(
  //     data.salePriceNoVat - data.purchasePriceNoVat
  //   ).toFixed(2);
  //   const profitPercent =
  //     data.purchasePriceNoVat > 0
  //       ? +((profitValue / data.purchasePriceNoVat) * 100).toFixed(2)
  //       : 0;

  //   return {
  //     ...data,
  //     purchasePriceWithVat,
  //     salePriceWithVat,
  //     profitValue,
  //     profitPercent,
  //   };
  // };

  const handleClose = () => {
    if (itemToEdit && hasChanges) {
      setShowUnsavedWarning(true);
    } else {
      onClose();
      setShowAdvancedForm(false);
    }
  };

  const handleContinueEdit = () => {
    setShowUnsavedWarning(false);
  };

  const handleDiscardAndClose = () => {
    setShowUnsavedWarning(false);
    setHasChanges(false);
    onClose();
    setShowAdvancedForm(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 1. Pastrojmë mesazhet e gabimeve në fillim
    setMsgBarcode("");
    setMsgArticle("");
    setMsgComment("");
    setGroupError("");
    // Supozojmë që ke edhe këto state-e për gabimet e fushave tjera:
    // setMsgGroup, setMsgUnit, setMsgPrice, etj.

    // --- VALIDIMET E FRONT-END ---

    // Emërtimi
    if (!formData.name || formData.name.trim() === "") {
      setMsgArticle("Emërtimi i artikullit është i detyrueshëm.");
      return;
    }
    if (formData.name.length > 1000) {
      setMsgArticle("Emërtimi duhet të jetë maksimum 1000 karaktere.");
      return;
    }
    if (articleExist > 0) {
      setMsgArticle("Ky emërtim ekziston në sistem.");
      return;
    }

    // Barkodi
    if (!formData.barcode || formData.barcode.trim() === "") {
      setMsgBarcode("Barkodi është i detyrueshëm.");
      return;
    }
    if (barcodeExist > 0) {
      setMsgBarcode("Ky barkod është i përdorur.");
      return;
    }

    // Grupi dhe Njësia (Dropdowns)
    if (!formData.groupId || formData.groupId === 0) {
      setGroupError("Ju lutem zgjidhni Grupin."); // Ose setMsgGroup(...)
      return;
    } else {
      setGroupError("");
    }
    if (!formData.unitId || formData.unitId === 0) {
      setUnitError("Ju lutem zgjidhni Njësinë bazë.");
      return;
    } else {
      setUnitError("");
    }
    if (!formData.ledgerId || formData.ledgerId === 0) {
      setLedgerError("Ju lutem zgjidhni llojin e artikullit.");
      return;
    } else {
      setLedgerError("");
    }
    if (!formData.vatId || formData.vatId === 0) {
      setVatError("Ju lutem zgjidhni normen e TVSH-së.");
      return;
    } else {
      setVatError("");
    }
    // Përshkrimi
    if (formData.comment && formData.comment.length > 800) {
      setMsgComment("Përshkrimi duhet të jetë maksimum 800 karaktere.");
      return;
    }

    setLoading(true);

    // Përgatitja e Detajeve
    // Kur showAdvancedForm=false, placeholder-i bosh nuk duhet të përdoret;
    // ndërtojmë detajin nga fushat kryesore të formës.
    let finalDetails;
    if (!showAdvancedForm) {
      const existingDetail = formData.articleotherDetails?.[0];
      finalDetails = [
        {
          articleSalesOptionsID: existingDetail?.articleSalesOptionsID || null,
          isActive: existingDetail?.isActive ?? true,
          companyUnitId: existingDetail?.companyUnitId || 0,
          typeOfSales: existingDetail?.typeOfSales || 1,
          newBarcode: formData.barcode || "",
          articleUnitID: formData.unitId || "",
          articleUnitQty: existingDetail?.articleUnitQty || 1,
          newSalesPrice: formData.salePriceWithVat || 0,
        },
      ];
    } else {
      finalDetails =
        formData?.articleotherDetails?.length > 0
          ? formData.articleotherDetails
          : [
              {
                articleSalesOptionsID: null,
                isActive: true,
                companyUnitId: 0,
                typeOfSales: 1,
                newBarcode: formData.barcode || "",
                articleUnitID: formData.unitId || "",
                articleUnitQty: 1,
                newSalesPrice: formData.salePriceWithVat || 0,
              },
            ];
    }

    const stateData = {
      Barcode: formData.barcode,
      ArticleName: formData.name,
      Description: formData.comment,
      GroupID: formData.groupId,
      UnitID: formData.unitId,
      LedgerID: formData.ledgerId,
      VAT: formData.vatId,
      ArticleProduction: formData.articleProduction || null,
      PurchasePrice: formData.purchasePriceWithVat,
      SalesPrice: formData.salePriceWithVat,
      IsActive: formData.isActive,
      TouchScreen: formData.showInPos,

      ArticleOtherDetails: finalDetails.map((detail) => ({
        ArticleSalesOptionsID: detail.articleSalesOptionsID || null,
        IsActive: detail.isActive ?? true,
        CompanyUnitId: parseInt(detail.companyUnitId) || 0,
        TypeOfSales: detail.typeOfSales || 1,
        NewBarcode: detail.newBarcode || formData.barcode,
        ArticleUnitID: parseInt(detail.articleUnitID) || 0,
        ArticleUnitQty: parseFloat(detail.articleUnitQty) || 1,
        NewSalesPrice: parseFloat(detail.newSalesPrice) || 0,
      })),
    };

    try {
      if (itemToEdit) {
        await updateArticle(itemToEdit, stateData);
      } else {
        await createArticle(stateData);
      }

      // Nëse çdo gjë shkon mirë
      onSuccess();
      onClose();
      resetForm();
      setHasChanges(false);
      fetchNextBarcode();
      if (setShowAdvancedForm) setShowAdvancedForm(false);
    } catch (err) {
      const errorMsg = extractErrorMessage(
        err,
        "Ndodhi një gabim gjatë ruajtjes së artikullit.",
      );

      // Lidhim gabimin e backend-it me fushën specifike në front-end
      if (errorMsg.toLowerCase().includes("barcode")) {
        setMsgBarcode(errorMsg);
        fetchNextBarcode(); // Rifreskojmë barkodin nëse ishte duplikati i fundit
      } else if (
        errorMsg.toLowerCase().includes("emertim") ||
        errorMsg.toLowerCase().includes("name")
      ) {
        setMsgArticle(errorMsg);
      } else if (
        errorMsg.toLowerCase().includes("grup") ||
        errorMsg.toLowerCase().includes("njësi")
      ) {
        errorAlert(errorMsg);
      } else {
        errorAlert(errorMsg);
      }
    } finally {
      setLoading(false);
    }
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // ... Validimet tua (Barcode, Name, etc.) - OK ...
  //   if (barcodeExist > 0) {
  //     setMsgBarcode("Ky barkod është përdorur");
  //     return;
  //   } else {
  //     setMsgBarcode("");
  //   }
  //   if (articleExist > 0) {
  //     setMsgArticle("Ky emertim ekziston");
  //     return;
  //   } else {
  //     setMsgArticle("");
  //   }
  //   if (formData.name.length > 1000) {
  //     setMsgArticle(
  //       "Emertimi Artikullit duhet te jetë maksimum 1000 karaktere",
  //     );
  //     return;
  //   } else {
  //     setMsgArticle("");
  //   }
  //   if (formData.comment.length > 800) {
  //     setMsgComment(
  //       "Pershkrimi Artikullit duhet te jetë maksimum 800 karaktere",
  //     );
  //     return;
  //   } else {
  //     setMsgComment("");
  //   }

  //   if (!formData.name) return;
  //   setLoading(true);

  //   const finalDetails =
  //     formData?.articleotherDetails?.length > 0
  //       ? formData.articleotherDetails
  //       : [
  //           {
  //             articleSalesOptionsID: null, // E rëndësishme!
  //             companyUnitId: 0,
  //             typeOfSales: 1,
  //             newBarcode: formData.barcode || "",
  //             articleUnitID: formData.unitId || "",
  //             articleUnitQty: 1,
  //             newSalesPrice: formData.salePriceWithVat || 0,
  //           },
  //         ];

  //   const stateData = {
  //     // Të dhënat kryesore
  //     Barcode: formData.barcode,
  //     ArticleName: formData.name,
  //     Description: formData.comment,
  //     GroupID: formData.groupId,
  //     UnitID: formData.unitId,
  //     LedgerID: formData.ledgerId,
  //     VAT: formData.vatId,
  //     ArticleProduction: formData.articleProduction || null,
  //     PurchasePrice: formData.purchasePriceWithVat,
  //     SalesPrice: formData.salePriceWithVat,
  //     IsActive: formData.isActive,
  //     TouchScreen: formData.showInPos,

  //     // Kjo pjesë është kyçe për EDITIM:
  //     ArticleOtherDetails: finalDetails.map((detail) => ({
  //       // SHTO KËTË LINJË: Nëse ka ID vjen nga DB, nëse jo është null (rresht i ri)
  //       ArticleSalesOptionsID: detail.articleSalesOptionsID || null,

  //       CompanyUnitId: parseInt(detail.companyUnitId) || 0,
  //       TypeOfSales: detail.typeOfSales || 1,
  //       NewBarcode: detail.newBarcode || formData.barcode,
  //       ArticleUnitID: parseInt(detail.articleUnitID) || 0,
  //       ArticleUnitQty: parseFloat(detail.articleUnitQty) || 1,
  //       NewSalesPrice: parseFloat(detail.newSalesPrice) || 0,
  //     })),
  //   };
  //   try {
  //     if (itemToEdit) {
  //       await updateArticle(itemToEdit, stateData);
  //     } else {
  //       await createArticle(stateData);
  //     }

  //     // Nese suksesi eshte OK:
  //     onSuccess();
  //     onClose();
  //     resetForm();
  //     fetchNextBarcode();
  //   } catch (err) {
  //     // 1. Kontrollojmë nëse backend-i ka kthyer një mesazh specifik (nga Middleware)
  //     const serverError =
  //       err.response?.data?.message || err.response?.data?.Message;

  //     // 2. Nëse nuk ka mesazh nga backend, përdorim gabimin e përgjithshëm të Axios
  //     const errorMsg =
  //       serverError ||
  //       "Ndodhi një gabim gjatë ruajtjes. Ju lutem provoni përsëri.";

  //     // 3. Shfaqja e gabimit (Këtu mund të përdorësh edhe një Toast library)
  //     alert(errorMsg);

  //     // Opsionale: Nëse gabimi thotë që barkodi ekziston, mund të rifreskosh barkodin automatikisht
  //     if (errorMsg.includes("barcode")) {
  //       fetchNextBarcode();
  //     }
  //   } finally {
  //     setLoading(false);
  //   }

  //   // try {
  //   //   if (itemToEdit) {
  //   //     await updateArticle(itemToEdit, stateData);
  //   //   } else {
  //   //     await createArticle(stateData);
  //   //   }

  //   //   onSuccess();
  //   //   onClose();
  //   //   resetForm();
  //   //   fetchNextBarcode();
  //   //   setShowAdvancedForm(false);
  //   // } catch (err) {
  //   //   const errorMsg = err.response?.data?.Message || err.message || "Gabim!";
  //   //   alert(errorMsg);
  //   // } finally {
  //   //   setLoading(false);
  //   // }
  // };

  const handleSaveUnit = async (data) => {
    await createUnit(data);
    loadUnits();
  };

  const handleSaveGroup = async (data) => {
    await createArticleGroup(data);
    loadGroups();
  };

  //Kodi per listen e grupeve
  const [groupName, setGroupName] = useState(null);
  const handleAutocompleteChangeGroupName = (event, value) => {
    if (value && value.GroupID) {
      if (isTrackingChanges && formData.groupId !== value.GroupID) {
        setHasChanges(true);
      }
      // setGroupId(value.GroupID);
      setFormData((prevState) => ({
        ...prevState,
        groupId: value.GroupID,
      }));
      setGroupName(value);
      setGroupError("");
    } else {
      if (isTrackingChanges && formData.groupId !== "") {
        setHasChanges(true);
      }
      // Në rast se vlera është pastruar
      setFormData((prevState) => ({
        ...prevState,
        groupId: "",
      }));
      setGroupName(null);
    }
  };

  const defaultPropsGroupName = {
    options: groups,
    getOptionLabel: (option) => `${option.GroupName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.GroupName}</span>
        </li>
      </>
    ),
  };

  //Kodi per listen e Njesis
  const [unitName, setUnitName] = useState(null);
  const handleAutocompleteChangeUnit = (event, value) => {
    if (value && value.UnitID) {
      if (isTrackingChanges && formData.unitId !== value.UnitID) {
        setHasChanges(true);
      }
      setFormData((prevState) => ({
        ...prevState,
        unitId: value.UnitID,
      }));
      setUnitName(value);
      setUnitError("");
    } else {
      if (isTrackingChanges && formData.unitId !== "") {
        setHasChanges(true);
      }
      // Në rast se vlera është pastruar
      setFormData((prevState) => ({
        ...prevState,
        unitId: "",
      }));
      setUnitName(null);
    }
  };

  const defaultPropsUnit = {
    options: units,
    getOptionLabel: (option) => `${option.UnitName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.UnitName}</span>
        </li>
      </>
    ),
  };

  //Kodi per listen e Ledger
  const [ledgerName, setLedgerName] = useState(null);
  const handleAutocompleteChangeLedger = (event, value) => {
    if (value && value.Ledgerid) {
      if (isTrackingChanges && formData.ledgerId !== value.Ledgerid) {
        setHasChanges(true);
      }
      setFormData((prevState) => ({
        ...prevState,
        ledgerId: value.Ledgerid,
      }));
      setLedgerName(value);
      setLedgerError("");
    } else {
      if (isTrackingChanges && formData.ledgerId !== "") {
        setHasChanges(true);
      }
      // Në rast se vlera është pastruar
      setFormData((prevState) => ({
        ...prevState,
        ledgerId: "",
      }));
      setLedgerName(null);
    }
  };

  const defaultPropsLedger = {
    options: ledgers,
    getOptionLabel: (option) => `${option.LedgerName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>{option.LedgerName}</span>
        </li>
      </>
    ),
  };

  // const handleAutocompleteVAT = (event, value) => {
  //   if (value) {
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       vatId: value.VATID,
  //     }));
  //     setVatPercent(value.VATPercent);
  //   } else {
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       vatId: "",
  //     }));
  //     setVatPercent(0);
  //   }
  // };

  const handleAutocompleteVAT = (event, value) => {
    if (isTrackingChanges) {
      const nextVatId = value?.VATID || "";
      if (formData.vatId !== nextVatId) {
        setHasChanges(true);
      }
    }

    if (!value) {
      setFormData((prev) => ({
        ...prev,
        vatId: "",
      }));
      setVatPercent(0);
      return;
    }

    setVatError("");
    const percent = value.VATPercent;

    setFormData((prev) => {
      const current = { ...prev, vatId: value.VATID };

      // nëse ekziston çmimi i blerjes pa TVSH
      if (current.purchasePriceNoVat) {
        const withVat = current.purchasePriceNoVat * (1 + percent / 100);
        current.purchasePriceWithVat = withVat;
      }

      // nëse ekziston çmimi i blerjes me TVSH
      if (current.purchasePriceWithVat && !current.purchasePriceNoVat) {
        const noVat = (current.purchasePriceWithVat * 100) / (100 + percent);
        current.purchasePriceNoVat = noVat;
      }

      // shitja pa TVSH
      if (current.salePriceNoVat) {
        const withVat = current.salePriceNoVat * (1 + percent / 100);
        current.salePriceWithVat = withVat;
      }

      // shitja me TVSH
      if (current.salePriceWithVat && !current.salePriceNoVat) {
        const noVat = (current.salePriceWithVat * 100) / (100 + percent);
        current.salePriceNoVat = noVat;
      }

      const pNo = current.purchasePriceNoVat || 0;
      const sNo = current.salePriceNoVat || 0;
      const pWith = current.purchasePriceWithVat || 0;
      const sWith = current.salePriceWithVat || 0;

      current.profitValue = sNo - pNo;
      current.profitPercent = pWith !== 0 ? (sWith / pWith - 1) * 100 : 0;

      return current;
    });

    setVatPercent(percent);
  };
  const defaultPropsVAT = {
    options: vat,
    getOptionLabel: (option) => `${option.VATName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            <b> {option.VATName}</b>
            <br />
          </span>
        </li>
      </>
    ),
  };

  const checkArticleName = async (articleName) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/chectArticleName",
        { headers, params: { articleName: articleName } },
      );
      setArticleExist(response.data[0].ArticleName);
      if (response.data[0].ArticleName > 0) {
        setMsgArticle("Artikulli me kete emertim ekziston");
      } else {
        setMsgArticle("");
      }
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchNextBarcode = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/getNewBarcode",
        {
          headers,
        },
      );
      // setBarcode(response.data.NextBarcode);

      setFormData((prevState) => ({
        ...prevState,
        barcode: response.data.NextBarcode,
      }));
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë.");
      }
    }
  };

  const checkBarcode = async (barcode) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Article/checkBarcode",
        { headers, params: { barcode: barcode } },
      );
      setBarcodeExsit(response.data[0].Barcode);

      if (response.data[0].Barcode > 0) {
        setMsgBarcode("Ky barkod është përdorur");
      } else {
        setMsgBarcode("");
      }
    } catch (error) {
      // errorAlert("Gabim në kërkesë:", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        );
      } else if (error.message) {
        // errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const fetchCompanyVATStatus = async (vatData) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Companies/getCompanyDetails",
        { headers },
      );
      const isCompanyVatDeclarant = response.data[0].VATDeclarant;

      setIsVatDeclarant(isCompanyVatDeclarant);

      // Nëse nuk është deklarues i TVSH-së, kërko VATID me VATPercent = 0
      if (!isCompanyVatDeclarant) {
        const vatZero = vatData.find((v) => v.VATPercent === 0);
        if (vatZero) {
          setFormData((prevState) => ({
            ...prevState,
            vatId: vatZero.VATID,
          }));
          // setVatId(vatZero.VATID);
        } else {
          errorAlert("Nuk u gjet ndonjë normë me VATPercent = 0");
        }
      }
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (error.response?.data?.errorMessage) {
        // errorAlert(
        //   `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`,
        // );
        errorAlert(`Gabim në marrjen e të dhënave`);
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  //Ky funksion perdoret per ta kalkuluar qmimin pa tvsh, bazuar ne parametrat e derguar
  // const calcPriceWith = (price, vatPercent, hasVAT) => {
  //   //gjeje qmimin pa tvsh bazuar ne qmimin me tvsh
  //   if (hasVAT === "withVAT") {
  //     return (Number(price) * Number(100)) / (Number(100) + Number(vatPercent));
  //   } else if (hasVAT === "noVAT") {
  //     return Number(price) * (Number(1) + Number(vatPercent) / Number(100));
  //   }
  // };

  // const calcPriceFromPriceWithVAT = async (price, vat, priceType) => {
  //   try {
  //     if (priceType === "purchaseWithVAT") {
  //       // const noVAT = (Number(price) * Number(100)) / (Number(100) + Number(vat));
  //       // setPurchaseNoVAT(calcPriceWith(price, vat, "withVAT"));
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         purchasePriceNoVat: calcPriceWith(price, vat, "withVAT"),
  //       }));
  //     } else if (priceType === "purchaseWithoutVAT") {
  //       // setPurchasePrice(calcPriceWith(price, vat, "noVAT"));
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         purchasePriceWithVat: calcPriceWith(price, vat, "noVAT"),
  //       }));
  //     } else if (priceType === "salesWithVAT") {
  //       // const noVAT = (Number(price) * Number(100)) / (Number(100) + Number(vat));
  //       const noVAT = calcPriceWith(price, vat, "withVAT");
  //       // setSalesNoVAT(noVAT);
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         salePriceNoVat: noVAT,
  //       }));
  //       const profitiNeVlerPaTVSH =
  //         Number(noVAT) - Number(formData.purchasePriceNoVat);
  //       // setValueProfit(profitiNeVlerPaTVSH);
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         profitValue: profitiNeVlerPaTVSH,
  //       }));
  //       const profitiVlerMeTVSH =
  //         Number(price) / Number(formData.purchasePriceWithVat);

  //       // setPercentProfit((Number(profitiVlerMeTVSH) - Number(1)) * Number(100));
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         profitPercent: (Number(profitiVlerMeTVSH) - Number(1)) * Number(100),
  //       }));
  //     } else if (priceType === "salesWithoutVAT") {
  //       const salesWithVAT = calcPriceWith(price, vat, "noVAT");
  //       // setSalesPrice(salesWithVAT);
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         salePriceWithVat: salesWithVAT,
  //       }));
  //       const profitiNeVlerPaTVSH =
  //         Number(price) - Number(formData.purchasePriceNoVat);
  //       // setValueProfit(profitiNeVlerPaTVSH);
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         profitValue: profitiNeVlerPaTVSH,
  //       }));
  //       const profitiVlerMeTVSH =
  //         Number(salesWithVAT) / Number(formData.purchasePriceWithVat);
  //       // setPercentProfit((Number(profitiVlerMeTVSH) - Number(1)) * Number(100));
  //       setFormData((prevState) => ({
  //         ...prevState,
  //         profitPercent: (Number(profitiVlerMeTVSH) - Number(1)) * Number(100),
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("Error during calculation:", error);
  //     // Perform any necessary error handling here
  //   }
  // };

  const calcPriceFromPriceWithVAT = (price, vat, priceType) => {
    const v = Number(price) || 0;
    const vatPercent = Number(vat) || 0;

    setFormData((prev) => {
      let current = { ...prev };

      if (priceType === "purchaseWithVAT") {
        current.purchasePriceWithVat = v;
        current.purchasePriceNoVat = (v * 100) / (100 + vatPercent);
      } else if (priceType === "purchaseWithoutVAT") {
        current.purchasePriceNoVat = v;
        current.purchasePriceWithVat = v * (1 + vatPercent / 100);
      } else if (priceType === "salesWithVAT") {
        current.salePriceWithVat = v;
        current.salePriceNoVat = (v * 100) / (100 + vatPercent);
      } else if (priceType === "salesWithoutVAT") {
        current.salePriceNoVat = v;
        current.salePriceWithVat = v * (1 + vatPercent / 100);
      }

      const purchaseNo = Number(current.purchasePriceNoVat) || 0;
      const saleNo = Number(current.salePriceNoVat) || 0;

      const purchaseWith = Number(current.purchasePriceWithVat) || 0;
      const saleWith = Number(current.salePriceWithVat) || 0;

      current.profitValue = saleNo - purchaseNo;

      current.profitPercent =
        purchaseWith !== 0 ? (saleWith / purchaseWith - 1) * 100 : 0;

      return current;
    });
  };

  const KalkulimiCmimitNgaProfitiNgaVlera = (
    valueProfit,
    priceWithoutVAT,
    vatPercent,
  ) => {
    // Calculate the selling price without VAT
    const cmimiShitjesPaTVSH = Number(priceWithoutVAT) + Number(valueProfit);
    // setSalesNoVAT(cmimiShitjesPaTVSH);
    setFormData((prevState) => ({
      ...prevState,
      salePriceNoVat: cmimiShitjesPaTVSH,
    }));
    // Calculate the profit percentage
    const profitiNePerqindje =
      (Number(valueProfit) / Number(priceWithoutVAT)) * Number(100);
    // setPercentProfit(profitiNePerqindje);
    setFormData((prevState) => ({
      ...prevState,
      profitPercent: profitiNePerqindje,
    }));
    // Calculate VAT and the selling price with VAT
    const TVSH =
      Number(cmimiShitjesPaTVSH) * (Number(vatPercent) / Number(100));
    const cmimiShitjesMeTVSH = Number(cmimiShitjesPaTVSH) + Number(TVSH);
    // setSalesPrice(cmimiShitjesMeTVSH);
    setFormData((prevState) => ({
      ...prevState,
      salePriceWithVat: cmimiShitjesMeTVSH,
    }));
  };

  function KalkulimiCmimitNgaProfitiNgaPerqindja(
    profitPercent,
    purchasePriceWithoutVAT,
    vatPercent,
  ) {
    // Kalkulo fitimin në përqindje
    const fitimiPerqindje =
      Number(purchasePriceWithoutVAT) * (Number(profitPercent) / Number(100));
    const cmimiShitjesPaTVSH =
      Number(purchasePriceWithoutVAT) + Number(fitimiPerqindje);
    // setSalesNoVAT(cmimiShitjesPaTVSH);
    setFormData((prevState) => ({
      ...prevState,
      salePriceNoVat: cmimiShitjesPaTVSH,
    }));
    // Kalkulo TVSH-në dhe çmimin e shitjes me TVSH
    const TVSH =
      Number(cmimiShitjesPaTVSH) * (Number(vatPercent) / Number(100));
    const cmimiShitjesMeTVSH = Number(cmimiShitjesPaTVSH) + Number(TVSH);
    // setSalesPrice(cmimiShitjesMeTVSH);
    setFormData((prevState) => ({
      ...prevState,
      salePriceWithVat: cmimiShitjesMeTVSH,
    }));
    // Kalkulo fitimin në vlerë
    const profitiNeVlere =
      Number(cmimiShitjesPaTVSH) - Number(purchasePriceWithoutVAT);
    // setValueProfit(profitiNeVlere);
    setFormData((prevState) => ({
      ...prevState,
      profitValue: profitiNeVlere,
    }));
  }

  useEffect(() => {
    if (vat.length > 0) {
      fetchCompanyVATStatus(vat);
    }
  }, [vat]);
  // useEffect(() => {
  //   fetchNextBarcode();
  // }, []);

  useEffect(() => {
    if (isOpen) {
      const loadData = async () => {
        const data = await fetchActiveCompanyUnits();

        if (data) {
          setCompanyUnits(data);
          // console.log(data);

          setCountCompanyUnit(data.length);
        } else {
          setCompanyUnits([]);
          setCountCompanyUnit(0);
        }
      };
      loadData();
    } else {
      resetForm();
    }
  }, [isOpen]);
  if (!isOpen) return null;

  return (
    <>
      <div className="NewArticleModal__overlay">
        <div className="NewArticleModal__overlay-container">
          <div className="NewArticleModal__overlay-container-header">
            <div>
              <h2 className="NewArticleModal__overlay-title">
                {itemToEdit ? "Edito artikullin" : "Artikull i ri"}
              </h2>
              <p className="NewArticleModal__overlay-desc">
                Plotësoni të dhënat më poshtë për të{" "}
                {itemToEdit ? "përditësuar" : "krijuar"} artikullin.
              </p>
            </div>
            <button
              type="button"
              className="NewArticleModal__overlay__close-btn"
              onClick={handleClose}
            >
              <X size={20} />
            </button>
          </div>
          {/* {showUnsavedWarning && (
            <div className="NewArticleModal__overlay__unsaved-warning">
              <AlertCircle />
              <span>
                Ndryshimet nuk janë ruajtur. Klikoni 'Mbyll' përsëri për t’i
                anuluar.
              </span>
            </div>
          )} */}
          {/* 
          <button type="submit" onClick={clickBtn}>
            click
          </button> */}

          <form
            onSubmit={handleSubmit}
            className="NewArticleModal__overlay-form"
          >
            <div className="NewArticleModal__overlay__grid-2cols">
              <div>
                <TextField
                  id="Barcode"
                  label="Kodi i Barkodit"
                  variant="filled"
                  fullWidth
                  value={formData.barcode}
                  disabled={enableSalesPrice}
                  onChange={(e) => {
                    handleChange("barcode", e.target.value);
                    checkBarcode(e.target.value);
                  }}
                  placeholder="Skano ose shkruaj bar-kodin"
                  error={Boolean(msgBarcode)}
                  helperText={msgBarcode || ""}
                />
                {/* <span style={{ color: "red" }}>
                  {msgBarcode && `${msgBarcode}`}
                </span> */}
              </div>

              <div>
                <TextField
                  id="ArticleName"
                  label="Emri i Artikullit"
                  variant="filled"
                  fullWidth
                  required
                  value={formData.name}
                  onChange={(e) => {
                    handleChange("name", e.target.value);
                    checkArticleName(e.target.value);
                  }}
                  placeholder="Shkruaj emrin e artikullit"
                  error={Boolean(msgArticle)}
                  helperText={msgArticle || ""}
                />
                {/* <span style={{ color: "red" }}>
                  {msgArticle && `${msgArticle}`}
                </span> */}
              </div>
            </div>
            <div>
              <TextField
                id="comment"
                label="Përshkrimi"
                variant="filled"
                fullWidth
                multiline
                minRows={2} // lartësia minimale e fushës
                value={formData.comment}
                onChange={(e) => handleChange("comment", e.target.value)}
                placeholder="Detaje shtesë..."
                error={Boolean(msgComment)}
                helperText={msgComment || ""}
              />
              {/* <span style={{ color: "red" }}>
                {msgComment && `${msgComment}`}
              </span> */}
            </div>
            <div className="NewArticleModal__overlay__categorization-grid">
              {/* <div className="NewArticleModal__overlay__input-with-button">
                <Autocomplete
                  {...defaultPropsGroupName}
                  id="GroupID"
                  includeInputInList
                  // value={groupName && groupName.GroupID ? groupName : null}
                  value={
                    groups.find(
                      (option) => option.GroupID === formData.groupId,
                    ) || null
                  }
                  onChange={handleAutocompleteChangeGroupName}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !option) return false;
                    return option.GroupID === value.GroupID;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label=""
                      placeholder="Zgjedh Grupin"
                      error={Boolean(groupError)}
                      helperText={groupError || ""}
                      variant="outlined"
                      fullWidth
                      FormHelperTextProps={{
                        sx: {
                          position: "absolute",
                          // bottom: "-15px", // E zhvendos tekstin poshtë pa zënë hapësirë
                          margin: 0,
                        },
                      }}
                    />
                  )}
                />
                <button
                  type="button"
                  className="NewArticleModal__overlay__add-button"
                  onClick={() => setIsGroupModalOpen(true)}
                >
                  <Plus />
                </button>
              </div> */}
              <div className="NewArticleModal__overlay__input-with-button">
                <Autocomplete
                  {...defaultPropsGroupName}
                  id="GroupID"
                  includeInputInList
                  value={
                    groups.find(
                      (option) => option.GroupID === formData.groupId,
                    ) || null
                  }
                  onChange={handleAutocompleteChangeGroupName}
                  isOptionEqualToValue={(option, value) =>
                    option?.GroupID === value?.GroupID
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Zgjedh Grupin"
                      error={Boolean(groupError)}
                      helperText={groupError || ""}
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
                <button
                  type="button"
                  className="NewArticleModal__overlay__add-button"
                  onClick={() => setIsGroupModalOpen(true)}
                >
                  <Plus />
                </button>
              </div>

              {/* Unit */}
              <div className="NewArticleModal__overlay__input-with-button">
                <Autocomplete
                  {...defaultPropsUnit}
                  id="UnitID"
                  includeInputInList
                  // value={unitName && unitName.UnitID ? unitName : null}
                  value={
                    units.find((option) => option.UnitID === formData.unitId) ||
                    null
                  }
                  onChange={handleAutocompleteChangeUnit}
                  isOptionEqualToValue={(option, value) => {
                    if (!option || !value) return false;
                    return option.UnitID === value.UnitID;
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zgjedh Njesin"
                      error={Boolean(unitError)}
                      helperText={unitError || ""}
                    />
                  )}
                />
                <button
                  type="button"
                  className="NewArticleModal__overlay__add-button"
                  onClick={() => setIsUnitModalOpen(true)}
                >
                  <Plus />
                </button>
              </div>
            </div>
            <div className="NewArticleModal__overlay__grid-2cols">
              <Autocomplete
                {...defaultPropsLedger}
                id="LedgerID"
                includeInputInList
                // value={ledgerName && ledgerName.Ledgerid ? ledgerName : null}
                value={
                  ledgers.find(
                    (option) => option.Ledgerid === formData.ledgerId,
                  ) || null
                }
                onChange={handleAutocompleteChangeLedger}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  return option.Ledgerid === value.Ledgerid;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Zgjedh llojin e artikullit"
                    error={Boolean(ledgerError)}
                    helperText={ledgerError || ""}
                  />
                )}
              />
              {/* </div> */}

              {/* <div className="form-group">
                <label>VAT Rate (%)</label>
                <select
                  value={formData.vatRate}
                  onChange={(e) => handleChange("vatRate", +e.target.value)}
                >
                  <option value={0}>0%</option>
                  <option value={5}>5%</option>
                  <option value={10}>10%</option>
                  <option value={20}>20%</option>
                </select>
              </div> */}
              <Autocomplete
                fullWidth
                {...defaultPropsVAT}
                id="VATID"
                includeInputInList
                onChange={handleAutocompleteVAT}
                value={
                  vat.find((option) => option.VATID === formData.vatId) || null
                }
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  return option.VATID === value.VATID;
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Norma e TVSH-së"
                    error={Boolean(vatError)}
                    helperText={vatError || ""}
                    // className="SalesDetail__Container__Form__TextField__2"
                  />
                )}
              />
            </div>
            {isVatDeclarant ? (
              <>
                <div className="NewArticleModal__overlay__pricing-section">
                  {/* <h3>Pricing & Profitability</h3> */}
                  <h3>Cmimi Blerjes</h3>
                  <div className="NewArticleModal__overlay__grid-2cols">
                    {/* <TextField
                      label="Çmimi Blerjes (pa TVSH)"
                      variant="filled"
                      fullWidth
                      value={formData.purchasePriceNoVat}
                      onChange={(e) =>
                        handleChange("purchasePriceNoVat", +e.target.value)
                      }
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "purchaseWithoutVAT",
                        )
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">€</InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#fff",
                        },
                        "& .MuiFilledInput-root:hover": {
                          backgroundColor: "#fff",
                        },
                        "& .MuiFilledInput-root.Mui-focused": {
                          backgroundColor: "#fff",
                        },
                      }}
                    /> */}
                    <PriceField
                      label="Çmimi Blerjes (pa TVSH)"
                      value={formData.purchasePriceNoVat}
                      onChange={(e) =>
                        handleChange("purchasePriceNoVat", e.target.value)
                      }
                      onBlur={() =>
                        calcPriceFromPriceWithVAT(
                          formData.purchasePriceNoVat,
                          vatPercent,
                          "purchaseWithoutVAT",
                        )
                      }
                    />

                    {/* <TextField
                      label="Çmimi Blerjes (me TVSH)"
                      variant="filled"
                      fullWidth
                      value={formData.purchasePriceWithVat}
                      onChange={(e) =>
                        handleChange("purchasePriceWithVat", +e.target.value)
                      }
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "purchaseWithVAT",
                        )
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">€</InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#fff",
                        },
                        "& .MuiFilledInput-root:hover": {
                          backgroundColor: "#fff",
                        },
                        "& .MuiFilledInput-root.Mui-focused": {
                          backgroundColor: "#fff",
                        },
                      }}
                    /> */}

                    <PriceField
                      label="Çmimi Blerjes (me TVSH)"
                      name="purchasePriceWithVat" // Emri i fushës në formData
                      value={formData.purchasePriceWithVat}
                      onChange={(e) => {
                        // E përditësojmë vlerën në state (e.target.value vjen si numër nga PriceField)
                        handleChange("purchasePriceWithVat", e.target.value);
                      }}
                      onBlur={() => {
                        // Kalkulimi bëhet kur useri del nga fusha, duke përdorur vlerën e fundit
                        calcPriceFromPriceWithVAT(
                          formData.purchasePriceWithVat,
                          vatPercent,
                          "purchaseWithVAT",
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="NewArticleModal__overlay__pricing-section">
                  <h3>Cmimi shitjes</h3>
                  <div className="NewArticleModal__overlay__grid-2cols">
                    {/* <TextField
                      label="Çmimi Shitjes (pa TVSH)"
                      variant="filled"
                      fullWidth
                      value={formData.salePriceNoVat}
                      onChange={(e) =>
                        handleChange("salePriceNoVat", +e.target.value)
                      }
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "salesWithoutVAT",
                        )
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">€</InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#fff",
                        },
                        "& .MuiFilledInput-root:hover": {
                          backgroundColor: "#fff",
                        },
                        "& .MuiFilledInput-root.Mui-focused": {
                          backgroundColor: "#fff",
                        },
                      }}
                      disabled={enableSalesPrice}
                    /> */}
                    <PriceField
                      label="Çmimi Shitjes (pa TVSH)"
                      name="salePriceNoVat"
                      value={formData.salePriceNoVat}
                      disabled={enableSalesPrice} // Kjo kontrollon nëse fusha është e bllokuar
                      onChange={(e) =>
                        handleChange("salePriceNoVat", e.target.value)
                      }
                      onBlur={() =>
                        calcPriceFromPriceWithVAT(
                          formData.salePriceNoVat,
                          vatPercent,
                          "salesWithoutVAT",
                        )
                      }
                    />

                    {/* <TextField
                      label="Çmimi Shitjes (me TVSH)"
                      variant="filled"
                      fullWidth
                      value={formData.salePriceWithVat}
                      onChange={(e) =>
                        handleChange("salePriceWithVat", +e.target.value)
                      }
                      onKeyUp={(event) =>
                        calcPriceFromPriceWithVAT(
                          event.target.value,
                          vatPercent,
                          "salesWithVAT",
                        )
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">€</InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiFilledInput-root": {
                          backgroundColor: "#fff",
                        },
                        "& .MuiFilledInput-root:hover": {
                          backgroundColor: "#fff",
                        },
                        "& .MuiFilledInput-root.Mui-focused": {
                          backgroundColor: "#fff",
                        },
                      }}
                      disabled={enableSalesPrice}
                    /> */}
                    <PriceField
                      label="Çmimi Shitjes (me TVSH)"
                      name="salePriceWithVat"
                      value={formData.salePriceWithVat}
                      disabled={enableSalesPrice}
                      onChange={(e) =>
                        handleChange("salePriceWithVat", e.target.value)
                      }
                      onBlur={() =>
                        calcPriceFromPriceWithVAT(
                          formData.salePriceWithVat,
                          vatPercent,
                          "salesWithVAT",
                        )
                      }
                    />
                  </div>

                  {enableSalesPrice && (
                    <div className="NewArticleModal__overlay__unsaved-warning">
                      <AlertCircle />
                      <span>
                        Artikulli ka shumë linja të çmimeve, çmimi i shitjes
                        editohet vetëm në tabelën më poshtë.
                      </span>
                    </div>
                  )}
                </div>
              </>
            ) : (
              <div className="NewArticleModal__overlay__pricing-section">
                <div className="NewArticleModal__overlay__grid-2cols">
                  {/* <TextField
                    label="Çmimi Blerjes (pa TVSH)"
                    variant="filled"
                    fullWidth
                    value={formData.purchasePriceNoVat}
                    onChange={(e) =>
                      handleChange("purchasePriceNoVat", +e.target.value)
                    }
                    onKeyUp={(event) =>
                      calcPriceFromPriceWithVAT(
                        event.target.value,
                        vatPercent,
                        "purchaseWithoutVAT",
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">€</InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#fff",
                      },
                      "& .MuiFilledInput-root:hover": {
                        backgroundColor: "#fff",
                      },
                      "& .MuiFilledInput-root.Mui-focused": {
                        backgroundColor: "#fff",
                      },
                    }}
                  /> */}
                  <PriceField
                    label="Çmimi Blerjes (pa TVSH)"
                    name="purchasePriceNoVat"
                    value={formData.purchasePriceNoVat}
                    onChange={(e) =>
                      handleChange("purchasePriceNoVat", e.target.value)
                    }
                    onBlur={() =>
                      calcPriceFromPriceWithVAT(
                        formData.purchasePriceNoVat,
                        vatPercent,
                        "purchaseWithoutVAT",
                      )
                    }
                  />

                  {/* <TextField
                    label="Çmimi Shitjes (pa TVSH)"
                    variant="filled"
                    fullWidth
                    value={formData.salePriceNoVat}
                    onChange={(e) =>
                      handleChange("salePriceNoVat", +e.target.value)
                    }
                    onKeyUp={(event) =>
                      calcPriceFromPriceWithVAT(
                        event.target.value,
                        vatPercent,
                        "salesWithoutVAT",
                      )
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">€</InputAdornment>
                      ),
                    }}
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#fff",
                      },
                      "& .MuiFilledInput-root:hover": {
                        backgroundColor: "#fff",
                      },
                      "& .MuiFilledInput-root.Mui-focused": {
                        backgroundColor: "#fff",
                      },
                    }}
                  /> */}
                  <PriceField
                    label="Çmimi Shitjes (pa TVSH)"
                    name="salePriceNoVat"
                    value={formData.salePriceNoVat}
                    onChange={(e) =>
                      handleChange("salePriceNoVat", e.target.value)
                    }
                    onBlur={() =>
                      calcPriceFromPriceWithVAT(
                        formData.salePriceNoVat,
                        vatPercent,
                        "salesWithoutVAT",
                      )
                    }
                  />
                </div>
              </div>
            )}

            <div className="NewArticleModal__overlay__pricing-section">
              <h3>Fitimi</h3>
              <div className="NewArticleModal__overlay__grid-2cols profit-display">
                {/* <TextField
                  label="Vlera e Fitimit"
                  variant="filled"
                  fullWidth
                  value={
                    formData.profitValue !== null &&
                    formData.profitValue !== undefined &&
                    formData.profitValue !== 0
                      ? Number(formData.profitValue).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                        })
                      : "0.00"
                  }
                  onChange={(e) => handleChange("profitValue", +e.target.value)}
                  onKeyUp={(event) =>
                    KalkulimiCmimitNgaProfitiNgaVlera(
                      event.target.value,
                      formData.purchasePriceNoVat,
                      vatPercent,
                    )
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">€</InputAdornment>
                    ),
                    className:
                      formData.profitValue >= 0
                        ? "profit-positive"
                        : "profit-negative",
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      backgroundColor: "#fff",
                    },
                    "& .MuiFilledInput-root:hover": {
                      backgroundColor: "#fff",
                    },
                    "& .MuiFilledInput-root.Mui-focused": {
                      backgroundColor: "#fff",
                    },
                  }}
                /> */}
                <PriceField
                  label="Vlera e Fitimit"
                  name="profitValue"
                  value={formData.profitValue}
                  onChange={(e) => handleChange("profitValue", e.target.value)}
                  onBlur={() =>
                    KalkulimiCmimitNgaProfitiNgaVlera(
                      formData.profitValue,
                      formData.purchasePriceNoVat,
                      vatPercent,
                    )
                  }
                  // Shtojmë stilimin dinamik për vlerat negative
                  sx={{
                    "& .MuiFilledInput-root": {
                      backgroundColor: "#fff",
                      color: formData.profitValue < 0 ? "red" : "green", // E bën tekstin kuq nëse është fitim negativ
                      fontWeight: "bold",
                    },
                    "& .MuiFilledInput-root:hover": { backgroundColor: "#fff" },
                    "& .MuiFilledInput-root.Mui-focused": {
                      backgroundColor: "#fff",
                    },
                  }}
                />

                {/* <TextField
                  label="Margjina e Fitimit (%)"
                  variant="filled"
                  fullWidth
                  value={
                    formData.profitPercent != null &&
                    formData.profitPercent !== 0
                      ? Number(formData.profitPercent).toLocaleString("en-US", {
                          minimumFractionDigits: 2,
                        })
                      : "0.00"
                  }
                  onChange={(e) =>
                    handleChange("profitPercent", e.target.value)
                  }
                  onKeyUp={(event) =>
                    KalkulimiCmimitNgaProfitiNgaPerqindja(
                      event.target.value,
                      formData.purchasePriceNoVat,
                      vatPercent,
                    )
                  }
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                    className:
                      formData.profitPercent >= 0
                        ? "profit-positive"
                        : "profit-negative",
                  }}
                  sx={{
                    "& .MuiFilledInput-root": {
                      backgroundColor: "#fff",
                    },
                    "& .MuiFilledInput-root:hover": {
                      backgroundColor: "#fff",
                    },
                    "& .MuiFilledInput-root.Mui-focused": {
                      backgroundColor: "#fff",
                    },
                  }}
                /> */}

                <PriceField
                  label="Margjina e Fitimit (%)"
                  name="profitPercent"
                  value={formData.profitPercent}
                  onChange={(e) =>
                    handleChange("profitPercent", e.target.value)
                  }
                  onBlur={() =>
                    KalkulimiCmimitNgaProfitiNgaPerqindja(
                      formData.profitPercent,
                      formData.purchasePriceNoVat,
                      vatPercent,
                    )
                  }
                  // Përshtasim simbolin në fillim
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                  }}
                  // Stilimi dinamik për përqindjet negative
                  sx={{
                    "& .MuiFilledInput-root": {
                      backgroundColor: "#fff",
                      color: formData.profitPercent < 0 ? "red" : "green",
                      fontWeight: "bold",
                    },
                  }}
                />
              </div>
            </div>

            {/* Flags */}
            <div className="NewArticleModal__overlay__flags">
              <div className="NewArticleModal__overlay__flags__checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={formData.isActive}
                    onChange={(e) => handleChange("isActive", e.target.checked)}
                  />
                  Is Active
                </label>
                <label>
                  <input
                    type="checkbox"
                    checked={formData.showInPos}
                    onChange={(e) =>
                      handleChange("showInPos", e.target.checked)
                    }
                  />
                  Show in POS / Box
                </label>
              </div>

              <div>
                <FormControlLabel
                  control={
                    <IOSSwitch
                      checked={showAdvancedForm}
                      onChange={(e) => {
                        if (isTrackingChanges) setHasChanges(true);
                        setShowAdvancedForm(e.target.checked);
                        addDefaultArticleDetail();
                      }}
                    />
                  }
                  label="Hap detaje"
                />
              </div>
            </div>

            {/* {formData.pricingMode === "advanced" && ( */}
            {showAdvancedForm && (
              <>
                {/* {countCompanyUnit > 0 && ( */}
                {countCompanyUnit > 0 && userCompanyUnitID === 0 && (
                  <>
                    <hr className="ArticleModal__separator" />
                    <section className="ArticleModal__company-units-section">
                      <div className="ArticleModal__units-wrapper">
                        <Autocomplete
                          multiple
                          options={companyUnits || []}
                          disableCloseOnSelect
                          getOptionLabel={(option) => option.UnitName}
                          value={companyUnits.filter((unit) =>
                            formData.articleotherDetails?.some(
                              (detail) => detail.companyUnitId === unit.UnitID,
                            ),
                          )}
                          // onChange={(event, newValue) => {
                          //   const newDetails = newValue.map((unit) => ({
                          //     companyUnitId: unit.UnitID,
                          //     newBarcode: formData.barcode,
                          //     articleUnitID: formData.unitId,
                          //     newSalesPrice: formData.salePriceWithVat,
                          //   }));

                          //   setFormData((prev) => ({
                          //     ...prev,
                          //     articleotherDetails: newDetails,
                          //   }));
                          // }}
                          onChange={(event, newValue) => {
                            if (isTrackingChanges) setHasChanges(true);
                            setFormData((prev) => {
                              const existing = prev.articleotherDetails || [];

                              // rreshtat që janë default (companyUnitId === null)
                              const baseRows = existing.filter(
                                (d) => d.companyUnitId === null,
                              );

                              // rreshtat për company units
                              const unitRows = newValue.map((unit) => {
                                const found = existing.find(
                                  (d) => d.companyUnitId === unit.UnitID,
                                );

                                if (found) return found;

                                return {
                                  isActive: true,
                                  companyUnitId: unit.UnitID,
                                  typeOfSales: 1,
                                  newBarcode: prev.barcode,
                                  articleUnitID: prev.unitId,
                                  articleUnitQty: null,
                                  newSalesPrice: prev.salePriceWithVat,
                                };
                              });

                              return {
                                ...prev,
                                articleotherDetails: [...baseRows, ...unitRows],
                              };
                            });
                          }}
                          renderOption={(props, option, { selected }) => (
                            <li {...props} key={option.UnitID}>
                              {selected ? checkedIcon : icon} {option.UnitName}
                            </li>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Company Units"
                              placeholder="Select units..."
                              variant="outlined"
                            />
                          )}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </section>
                  </>
                )}
                <section className="ArticleModal__units-section">
                  <div className="ArticleModal__units-header">
                    <label className="ArticleModal__label">Units</label>
                  </div>
                  {/* Desktop Table View */}
                  <div className="ArticleModal__units-table-wrapper">
                    <TableContainer
                      component={Paper}
                      className="ArticleModal__table-container"
                    >
                      <Table size="small">
                        <TableHead className="ArticleModal__table-head">
                          <TableRow>
                            {countCompanyUnit > 0 && (
                              <>
                                <TableCell>Njesia Organizative</TableCell>
                              </>
                            )}
                            <TableCell>Barkodi</TableCell>
                            <TableCell>Lloji shitjes</TableCell>
                            <TableCell>Njesia artikullit</TableCell>
                            <TableCell>Sasia Shumices</TableCell>
                            <TableCell>Cmimi</TableCell>

                            {/* <TableCell align="center">Base Unit</TableCell> */}
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(formData.articleotherDetails || []).map(
                            (details, index) => (
                              <TableRow key={index}>
                                {/* {countCompanyUnit > 0 && (
                                  <TableCell>
                                    <SimpleAutoSelect
                                      options={companyUnits || []}
                                      value={
                                        details.companyUnitId
                                          ? companyUnits.find(
                                              (opt) =>
                                                opt.UnitID ===
                                                details.companyUnitId,
                                            ) || null
                                          : null
                                      }
                                      onChange={(newValue) =>
                                        updateOtherArticleDetils(
                                          index,
                                          "companyUnitId",
                                          newValue?.UnitID || "",
                                        )
                                      }
                                      getOptionLabel={(opt) =>
                                        opt?.UnitName || ""
                                      }
                                      label="Njesia organizative"
                                      width="200px"
                                    />
                                  </TableCell>
                                )} */}
                                {countCompanyUnit > 0 && (
                                  <TableCell>
                                    {userCompanyUnitID > 0 ? (
                                      /* 1. Nëse është Unit User: Shfaqim vetëm emrin si tekst */
                                      // <span
                                      //   style={{
                                      //     fontWeight: "bold",
                                      //     color: "#555",
                                      //   }}
                                      // >
                                      //   {companyUnits.find(
                                      //     (u) =>
                                      //       u.UnitID === userCompanyUnitID,
                                      //   )?.UnitName || "Njesia juaj"}
                                      // </span>
                                      <TextField
                                        label="Njesia organizative"
                                        variant="outlined"
                                        fullWidth
                                        value={
                                          companyUnits.find(
                                            (u) =>
                                              u.UnitID === userCompanyUnitID,
                                          )?.UnitName || ""
                                        }
                                        disabled
                                        sx={{ width: "200px" }} // full width si select lista
                                      />
                                    ) : (
                                      /* 2. Nëse është Admin: Shfaqim Select-in normal */
                                      <SimpleAutoSelect
                                        options={companyUnits || []}
                                        value={
                                          details.companyUnitId
                                            ? companyUnits.find(
                                                (opt) =>
                                                  opt.UnitID ===
                                                  details.companyUnitId,
                                              ) || null
                                            : null
                                        }
                                        onChange={(newValue) =>
                                          updateOtherArticleDetils(
                                            index,
                                            "companyUnitId",
                                            newValue?.UnitID || "",
                                          )
                                        }
                                        getOptionLabel={(opt) =>
                                          opt?.UnitName || ""
                                        }
                                        label="Njesia organizative"
                                        width="200px"
                                      />
                                    )}
                                  </TableCell>
                                )}

                                <TableCell>
                                  <TextField
                                    label="Barkodi"
                                    variant="outlined"
                                    value={details.newBarcode || ""} // siguro që nuk është undefined
                                    onChange={(e) =>
                                      updateOtherArticleDetils(
                                        index,
                                        "newBarcode",
                                        e.target.value,
                                      )
                                    }
                                    sx={{ width: "200px" }} // full width si select lista
                                  />
                                </TableCell>
                                <TableCell>
                                  <SimpleAutoSelect
                                    options={saleTypes || []}
                                    value={
                                      details.typeOfSales
                                        ? saleTypes.find(
                                            (opt) =>
                                              opt.id === details.typeOfSales,
                                          ) || null
                                        : null
                                    }
                                    onChange={(newValue) =>
                                      updateOtherArticleDetils(
                                        index,
                                        "typeOfSales",
                                        newValue?.id || "",
                                      )
                                    }
                                    getOptionLabel={(opt) => opt?.name || ""}
                                    label="Shitje pakicë/shumicë"
                                    width="200px"
                                  />
                                </TableCell>
                                <TableCell>
                                  <SimpleAutoSelect
                                    options={units || []}
                                    value={
                                      details.articleUnitID
                                        ? units.find(
                                            (opt) =>
                                              opt.UnitID ===
                                              details.articleUnitID,
                                          ) || null
                                        : null
                                    }
                                    onChange={(newValue) =>
                                      updateOtherArticleDetils(
                                        index,
                                        "articleUnitID",
                                        newValue?.UnitID || "",
                                      )
                                    }
                                    getOptionLabel={(opt) =>
                                      opt?.UnitName || ""
                                    }
                                    label="Njesia e artikullit"
                                    width="200px"
                                  />
                                </TableCell>
                                {/* <TextField
                                    label="Sasia Shumices"
                                    variant="outlined"
                                    value={details.articleUnitQty || ""} // siguro që nuk është undefined
                                    onChange={(e) =>
                                      updateOtherArticleDetils(
                                        index,
                                        "articleUnitQty",
                                        e.target.value,
                                      )
                                    }
                                    sx={{ width: "200px" }} // full width si select lista
                                  /> */}
                                <TableCell>
                                  <TextField
                                    label="Sasia Shumices"
                                    variant="outlined"
                                    value={details.articleUnitQty || ""}
                                    disabled={details.typeOfSales !== 2}
                                    onChange={(e) =>
                                      updateOtherArticleDetils(
                                        index,
                                        "articleUnitQty",
                                        e.target.value,
                                      )
                                    }
                                    sx={{ width: "200px" }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    label="Cmimi shitjes"
                                    variant="outlined"
                                    value={details.newSalesPrice || ""} // siguro që nuk është undefined
                                    onChange={(e) =>
                                      updateOtherArticleDetils(
                                        index,
                                        "newSalesPrice",
                                        e.target.value,
                                      )
                                    }
                                    sx={{ width: "200px" }} // full width si select lista
                                  />
                                </TableCell>
                                <TableCell>
                                  <Button
                                    onClick={() =>
                                      removeOtherArticleDetails(index)
                                    }
                                    className="ArticleModal__remove-btn"
                                  >
                                    <Trash2 size={16} />
                                  </Button>
                                </TableCell>
                              </TableRow>
                            ),
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>

                  {/* Mobile Card View */}
                  {/* <div className="ArticleModal__units-mobile-wrapper">
                    {(formData.articleotherDetails || []).map((details, index) => (
                      <div key={index} className="ArticleModal__unit-card">
                        <Button
                          onClick={() => removeOtherArticleDetails(index)}
                          className="ArticleModal__remove-btn-mobile"
                        >
                          <Trash2 size={16} />
                        </Button>
                        <div className="ArticleModal__unit-inputs">
                          <div className="ArticleModal__input-group">
                            <label className="ArticleModal__input-label">
                              Unit
                            </label>
                            <input
                              type="text"
                              value={unit.unit}
                              className="ArticleModal__input"
                              onChange={(e) =>
                                updateOtherArticleDetils(
                                  index,
                                  "unit",
                                  e.target.value,
                                )
                              }
                            />
                            {countCompanyUnit > 0 && (
                                <SimpleAutoSelect
                                  options={companyUnits || []}
                                  value={
                                    details.companyUnitId
                                      ? companyUnits.find(
                                          (opt) =>
                                            opt.UnitID ===
                                            details.companyUnitId,
                                        ) || null
                                      : null
                                  }
                                  onChange={(newValue) =>
                                    updateOtherArticleDetils(
                                      index,
                                      "companyUnitId",
                                      newValue?.UnitID || "",
                                    )
                                  }
                                  getOptionLabel={(opt) => opt?.UnitName || ""}
                                  label="Njesia organizative"
                                  width="200px"
                                />
                            )}
                          </div>
                          <div className="ArticleModal__input-group">
                            <label className="ArticleModal__input-label">
                              Factor
                            </label>
                            <input
                              type="number"
                              value={unit.conversionFactor}
                              className="ArticleModal__input"
                              onChange={(e) =>
                                updateOtherArticleDetils(
                                  index,
                                  "conversionFactor",
                                  parseFloat(e.target.value),
                                )
                              }
                            />
                                <TextField
                                    label="Barkodi"
                                    variant="outlined"
                                    value={details.newBarcode || ""}
                                    onChange={(e) =>
                                      updateOtherArticleDetils(
                                        index,
                                        "newBarcode",
                                        e.target.value,
                                      )
                                    }
                                    sx={{ width: "200px" }}
                                  />
                          </div>
                        </div>
                        <div className="ArticleModal__base-unit-mobile">
                          <Radio
                            checked={unit.isBase}
                            onChange={() =>
                              updateOtherArticleDetils(index, "isBase", true)
                            }
                            name="baseUnitMobile"
                            color="primary"
                          />
                          <label className="ArticleModal__base-unit-label">
                            Base Unit
                          </label>
                            <SimpleAutoSelect
                                    options={saleTypes || []}
                                    value={
                                      details.companyUnitId
                                        ? saleTypes.find(
                                            (opt) =>
                                              opt.id === details.typeOfSales,
                                          ) || null
                                        : null
                                    }
                                    onChange={(newValue) =>
                                      updateOtherArticleDetils(
                                        index,
                                        "typeOfSales",
                                        newValue?.id || "",
                                      )
                                    }
                                    getOptionLabel={(opt) => opt?.name || ""}
                                    label="Shitje pakicë/shumicë"
                                    width="200px"
                                  />
                        </div>
                      </div>
                    ))}
                  </div> */}
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={addOtherArticleDetails}
                    startIcon={<Plus size={16} />}
                    className="ArticleModal__add-unit-btn"
                  >
                    Add Unit
                  </Button>
                </section>
                <hr className="ArticleModal__separator" />
              </>
            )}

            {/* Section 4: Prices */}
            {/* <section className="ArticleModal__prices-section">
              <label className="ArticleModal__section-label">Prices</label>

              {formData.pricingMode === "simple" ? (
                <div className="ArticleModal__simple-price-card">
                  <div className="ArticleModal__grid-2">
                    <div className="ArticleModal__input-group">
                      <label
                        htmlFor="simplePrice"
                        className="ArticleModal__input-label"
                      >
                        Price
                      </label>
                      <TextField
                        id="simplePrice"
                        type="number"
                        size="small"
                        value={formData.simplePrice || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            simplePrice: parseFloat(e.target.value),
                          })
                        }
                        className="ArticleModal__input"
                        variant="outlined"
                      />
                    </div>
                    <div className="ArticleModal__input-group">
                      <label
                        htmlFor="simpleCurrency"
                        className="ArticleModal__input-label"
                      >
                        Currency
                      </label>
                      <Select
                        value={formData.simpleCurrency}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            simpleCurrency: e.target.value,
                          })
                        }
                        displayEmpty
                        className="ArticleModal__input"
                        size="small"
                      >
                        {CURRENCIES.map((c) => (
                          <MenuItem key={c} value={c}>
                            {c}
                          </MenuItem>
                        ))}
                      </Select>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="space-y-3">
                  <div className="ArticleModal__add-price-btn-wrapper">
                    <Button
                      variant="outlined"
                      size="small"
                      startIcon={<Plus size={16} />}
                      onClick={addPrice}
                      className="ArticleModal__add-price-btn"
                    >
                      Add Price
                    </Button>
                  </div>

                  <div className="space-y-3">
                    {(formData.prices || []).map((price, index) => (
                      <div
                        key={index}
                        className="ArticleModal__price-row group"
                      >
                        <div className="ArticleModal__price-row-header">
                          <span className="ArticleModal__price-row-title">
                            Price Row #{index + 1}
                          </span>
                          <Button
                            variant="text"
                            size="small"
                            onClick={() => removePrice(index)}
                            className="ArticleModal__remove-price-btn"
                          >
                            <X size={16} />
                          </Button>
                        </div>

                        <div className="ArticleModal__grid-5">
                          <div>
                            <label className="ArticleModal__input-label">
                              Company Unit
                            </label>
                            <Select
                              value={price.companyUnitId || "all"}
                              onChange={(e) =>
                                updatePrice(
                                  index,
                                  "companyUnitId",
                                  e.target.value,
                                )
                              }
                              size="small"
                              className="ArticleModal__input"
                            >
                              <MenuItem value="all">All Units</MenuItem>
                              {companyUnits.map((u) => (
                                <MenuItem key={u.id} value={u.id}>
                                  {u.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                          <div>
                            <label className="ArticleModal__input-label">
                              Unit
                            </label>
                            <Select
                              value={price.unit || ""}
                              onChange={(e) =>
                                updatePrice(index, "unit", e.target.value)
                              }
                              size="small"
                              className="ArticleModal__input"
                            >
                              {(formData.measurementUnits || []).map((u) => (
                                <MenuItem key={u.unit} value={u.unit}>
                                  {u.unit}
                                </MenuItem>
                              ))}

                              {BASE_UNITS.filter(
                                (bu) =>
                                  !(formData.measurementUnits || []).find(
                                    (mu) => mu.unit === bu,
                                  ),
                              ).map((bu) => (
                                <MenuItem key={bu} value={bu}>
                                  {bu}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                          <div>
                            <label className="ArticleModal__input-label">
                              Type
                            </label>
                            <Select
                              value={price.priceType || ""}
                              onChange={(e) =>
                                updatePrice(index, "priceType", e.target.value)
                              }
                              size="small"
                              className="ArticleModal__input"
                            >
                              {PRICE_TYPES.map((t) => (
                                <MenuItem key={t} value={t}>
                                  {t}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                          <div>
                            <label className="ArticleModal__input-label">
                              Price
                            </label>
                            <TextField
                              type="number"
                              size="small"
                              value={price.amount || ""}
                              onChange={(e) =>
                                updatePrice(
                                  index,
                                  "amount",
                                  parseFloat(e.target.value),
                                )
                              }
                              className="ArticleModal__input"
                              variant="outlined"
                            />
                          </div>
                          <div>
                            <label className="ArticleModal__input-label">
                              Currency
                            </label>
                            <Select
                              value={price.currency || ""}
                              onChange={(e) =>
                                updatePrice(index, "currency", e.target.value)
                              }
                              size="small"
                              className="ArticleModal__input"
                            >
                              {CURRENCIES.map((c) => (
                                <MenuItem key={c} value={c}>
                                  {c}
                                </MenuItem>
                              ))}
                            </Select>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </section> */}

            {/* Section 5: Barcodes */}
            {/* <Box sx={{ mt: 4 }}>
              <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={2}
              >
                <Typography variant="h6" fontWeight={600}>
                  Barcodes
                </Typography>

                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<Plus size={16} />}
                  onClick={addBarcode}
                >
                  Add Barcode
                </Button>
              </Box>

              {(formData.barcodes || []).length === 0 && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  fontStyle="italic"
                >
                  No barcodes added yet.
                </Typography>
              )}

              {(formData.barcodes || []).map((barcode, index) => (
                <Box
                  key={index}
                  display="flex"
                  flexDirection={{ xs: "column", sm: "row" }}
                  gap={2}
                  alignItems={{ sm: "center" }}
                  mb={2}
                  p={2}
                  border="1px solid #eee"
                  borderRadius={2}
                  bgcolor="#fafafa"
                >
                  <TextField
                    label="Barcode Number"
                    value={barcode.number || ""}
                    onChange={(e) =>
                      updateBarcode(index, "number", e.target.value)
                    }
                    size="small"
                    fullWidth
                  />
                  <Select
                    value={barcode.linkedUnit || ""}
                    onChange={(e) =>
                      updateBarcode(index, "linkedUnit", e.target.value)
                    }
                    size="small"
                    displayEmpty
                    sx={{ minWidth: 150 }}
                  >
                    <MenuItem value="">
                      <em>Unit</em>
                    </MenuItem>

                    {(formData.measurementUnits || []).map((u) => (
                      <MenuItem key={u.unit} value={u.unit}>
                        {u.unit}
                      </MenuItem>
                    ))}

                    {BASE_UNITS.filter(
                      (bu) =>
                        !(formData.measurementUnits || []).find(
                          (mu) => mu.unit === bu,
                        ),
                    ).map((bu) => (
                      <MenuItem key={bu} value={bu}>
                        {bu}
                      </MenuItem>
                    ))}
                  </Select>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={barcode.isPrimary || false}
                        onChange={(e) =>
                          updateBarcode(index, "isPrimary", e.target.checked)
                        }
                      />
                    }
                    label="Primary"
                  />
                  <IconButton
                    onClick={() => removeBarcode(index)}
                    color="error"
                  >
                    <Trash2 size={18} />
                  </IconButton>
                </Box>
              ))}
            </Box> */}
            {showUnsavedWarning && (
              <Dialog
                open={showUnsavedWarning}
                onClose={handleContinueEdit}
                maxWidth="xs"
                fullWidth
              >
                <DialogTitle>Ndryshime të paruajtura</DialogTitle>
                <DialogContent>
                  Keni bërë ndryshime që nuk janë ruajtur. A doni të mbyllni
                  pa i ruajtur?
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleContinueEdit}>Vazhdo editimin</Button>
                  <Button color="error" variant="contained" onClick={handleDiscardAndClose}>
                    Mbyll pa ruajtur
                  </Button>
                </DialogActions>
              </Dialog>
            )}
            <div className="NewArticleModal__overlay__modal-footer">
              <CloseFormButton
                className="NewArticleModal__overlay__btn-outline"
                text="Mbylle"
                onClick={handleClose}
              />
              <AddAnElementButton
                type="submit"
                className="NewArticleModal__overlay__btn-primary"
                text={loading ? "Duke u ruajtur..." : "Ruaj Artikullin"}
                // icon="fas fa-save"
                disabled={loading || !formData.name || (itemToEdit && !hasChanges)}
              />
            </div>
          </form>
        </div>
      </div>

      <ArticleGroupModal
        isOpen={isGroupModalOpen}
        onClose={() => setIsGroupModalOpen(false)}
        onSave={handleSaveGroup}
        // initialData={editingGroups}
      />
      <UnitModal
        isOpen={isUnitModalOpen}
        onClose={() => setIsUnitModalOpen(false)}
        onSave={handleSaveUnit}
        // initialData={editingUnit}
      />
    </>
  );
}
